// Snooze + "a sign-in just happened" flag for the post-login 2FA nudge (docs/specs/authenticator-mfa-nudge.md).
// localStorage is acceptable for step 1 only: nothing depends on the count, and a new browser asking once
// more is the safe direction. Every read/write is try/catch: unreadable storage = not snoozed, never a throw.
export const SNOOZE_DAYS = 7; // Amar, 2026-10-22: GitHub's maximum, inside Entra's 0-14
export const PENDING_KEY = "mfa_nudge_pending";

const DAY_MS = 24 * 60 * 60 * 1000;
const snoozeKey = (userid) => `mfa_nudge:${userid}`;

const readEntry = (userid) => {
  try {
    const entry = JSON.parse(localStorage.getItem(snoozeKey(userid)));
    return entry && typeof entry === "object" && !Array.isArray(entry) ? entry : null;
  } catch (e) {
    return null;
  }
};

export const isSnoozed = (userid, now = Date.now()) => {
  const until = Date.parse(readEntry(userid)?.snoozedUntil);
  return Number.isFinite(until) && now < until;
};

export const snoozeNudge = (userid, now = Date.now()) => {
  const skips = Number(readEntry(userid)?.skips) || 0;
  const entry = { snoozedUntil: new Date(now + SNOOZE_DAYS * DAY_MS).toISOString(), skips: skips + 1 };
  try {
    localStorage.setItem(snoozeKey(userid), JSON.stringify(entry));
  } catch (e) {
    console.error("2FA nudge: could not save the snooze", e?.message);
  }
};

export const markNudgePending = () => {
  try {
    sessionStorage.setItem(PENDING_KEY, "1");
  } catch (e) {
    console.error("2FA nudge: could not flag the sign-in", e?.message);
  }
};

export const isNudgePending = () => {
  try {
    return sessionStorage.getItem(PENDING_KEY) === "1";
  } catch (e) {
    return false;
  }
};

export const clearNudgePending = () => {
  try {
    sessionStorage.removeItem(PENDING_KEY);
  } catch (e) {
    console.error("2FA nudge: could not clear the sign-in flag", e?.message);
  }
};
